module.exports = __webpack_public_path__ + "img/function08.ecfc95fe.png";